import React from "react";
import { Plus, Trash2 } from "lucide-react";

export const ServicesTab = ({ services, showForm, setShowForm, form, setForm, onAdd, onDelete }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h3 className="text-lg font-medium text-[#0F172A]" style={{ fontFamily: "'Playfair Display', serif" }}>My Services</h3>
      <button onClick={() => setShowForm(!showForm)} className="btn-primary text-sm flex items-center gap-2" data-testid="add-service-btn">
        <Plus size={14} /> Add Service
      </button>
    </div>
    {showForm && (
      <div className="card-flat">
        <div className="grid md:grid-cols-2 gap-4 mb-4">
          <input placeholder="Service name*" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            className="border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A]" data-testid="service-name-input" />
          <input placeholder="Category" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}
            className="border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A]" />
          <input type="number" placeholder="Duration (mins)" value={form.duration} onChange={e => setForm(f => ({ ...f, duration: parseInt(e.target.value) }))}
            className="border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A]" />
          <input type="number" placeholder="Price (₹)" value={form.price} onChange={e => setForm(f => ({ ...f, price: parseFloat(e.target.value) }))}
            className="border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A]" data-testid="service-price-input" />
          <textarea placeholder="Description" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
            className="border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A] md:col-span-2 resize-none" rows={2} />
        </div>
        <div className="flex gap-3">
          <button onClick={onAdd} className="btn-primary text-sm" data-testid="save-service-btn">Save Service</button>
          <button onClick={() => setShowForm(false)} className="btn-secondary text-sm">Cancel</button>
        </div>
      </div>
    )}
    {services.length === 0 ? (
      <div className="card-flat text-center py-8 text-[#52525B] text-sm">No services yet. Add your first service offering.</div>
    ) : (
      <div className="grid md:grid-cols-2 gap-4" data-testid="services-list">
        {services.map((svc) => (
          <div key={svc.service_id} className="card-flat">
            <div className="flex justify-between items-start mb-2">
              <h4 className="font-semibold text-sm text-[#0F172A]">{svc.name}</h4>
              <button onClick={() => onDelete(svc.service_id)} className="text-red-400 hover:text-red-600 transition-colors">
                <Trash2 size={14} />
              </button>
            </div>
            <p className="text-xs text-[#52525B] mb-3">{svc.description}</p>
            <div className="flex items-center gap-3 text-xs text-[#A1A1AA]">
              <span>{svc.duration} mins</span>
              <span className="font-bold text-[#0F172A]">₹{svc.price?.toLocaleString("en-IN")}</span>
              {svc.category && <span className="bg-[#F4F4F1] px-2 py-0.5 rounded-sm">{svc.category}</span>}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
